import { render, staticRenderFns } from "./CheckoutComment.vue?vue&type=template&id=61cb6a06"
import script from "./CheckoutComment.vue?vue&type=script&lang=js"
export * from "./CheckoutComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports